import { useEffect, useMemo } from 'react';
import { UseFormReturn, useForm } from 'react-hook-form';

import { WorkflowConfig } from '~/data/workflows';
import { useYupValidationResolver } from '~/hooks/useYupValidationResolver';
import { WorkflowConfigFormValues } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/components/WorkflowConfigDialog/component';
import { useValidationSchema } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView/components/WorkflowConfigDialog/useValidationSchema';

type PropsType = {
  workflowConfig: WorkflowConfig;
};

type UseWorkflowConfigFormOutput = {
  form: UseFormReturn<WorkflowConfigFormValues>;
};

export const useWorkflowConfigForm = (
  props: PropsType,
): UseWorkflowConfigFormOutput => {
  const { workflowConfig } = props;
  const { workflow } = workflowConfig;

  const validationSchema = useValidationSchema();
  // Form validation

  const resolver = useYupValidationResolver(validationSchema);

  const initialFieldValues: WorkflowConfigFormValues | {} = useMemo(() => {
    if (!!workflow) {
      const initialApprovalSteps =
        workflow.approvalSteps.length === 0
          ? {
              approvalSteps: [
                {
                  roleNames: [],
                  seq: 1,
                },
              ],
            }
          : {};

      return {
        ...workflow,
        ...initialApprovalSteps,
      };
    }

    return {};
  }, [workflow]);

  const form = useForm<WorkflowConfigFormValues>({
    mode: 'all',
    defaultValues: initialFieldValues,
    resolver: resolver as never,
  });
  const { reset } = form;

  useEffect(() => {
    reset(initialFieldValues);
  }, [reset, initialFieldValues]);

  return {
    form,
  };
};
